import styles from './style.module.scss';

export const Footer = () => (
  <div className={styles.footer}>
    <div className={styles.inner}>
      <div className="row">
        <div className="col-lg-9">
          <p>&copy; 2019 - {new Date().getFullYear()} Wahed Inc. All rights reserved.</p>
        </div>
      </div>
    </div>
  </div>
);
